import React, { useContext, useRef, useState } from "react";
import { CircularProgress, Grid2 } from "@mui/material";
//styling
import styles from "./SiteMigration.module.scss";
// local import
import SiteHeaderCard from "../../Components/HeaderComponent/Header";
import { useSelector } from "react-redux";
import { Actions } from "../../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../../Utils/storeUtils";
import {
  adminApi,
  lastSegmentPath,
  STAGING,
} from "../../../../../../Utils/roconConstants";
import {
  siteDetails,
  getStagingEnv,
  staging,
} from "../../../../../../Utils/sitePages";
import { useMakeApiCalls } from "../../../../../../Hooks/useMakeApiCalls";
import { useLocation, useParams } from "react-router-dom";
import CurrentSiteInfo from "../../../../../../GlobalComponents/CurrentSiteInfo/CurrentSiteInfo";
import SiteDetails from "../../../../../../GlobalComponents/MigrateSiteDetails/MigrateSiteDetails";
import TabsComponent from "../../../../../../GlobalComponents/TabsComponent/TabsComponent";
import SelfMigrate from "./Components/SelfMigrate/SelfMigrate";
import ManualMigration from "./Components/ManualMigration/ManualMigration";
import CustomButton from "../../../../../../GlobalComponents/CustomButton/CustomButton";
import { useEmailId } from "../../../../../../Utils/utils";
import FormPopup from "../../../../../../GlobalComponents/FormPopup/FormPopup";
import { ReactComponent as MigrateProcessing } from "../../../../AdminAssets/svg/migrateProcessing.svg";
import AuthContext from "../../../../../../store/auth-context";

const tabs = [
  { title: "Migrate via Plugin", value: "MigrateViaPlugin" },
  { title: "Migrate via Backups", value: "MigrateViaBackups" },
  { title: "Request Expert Migration", value: "RequestExpertMigration" },
];

export default function SiteMigration() {
  const targetRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [isMultisite, setIsMultisite] = useState("");
  const [hasImportantDirs, setHasImportantDirs] = useState("");
  const [cardStatus, setCardStatus] = useState({
    title: "Migrate via Plugin",
    value: "MigrateViaPlugin",
  });
  const [isCurrentHosting, setISCurrentHosting] = useState({
    currenthosting: "",
    currenthostingerror: false,
    specifydirectory: "",
    specifydirectoryerror: false,
  });
  const [wpAdmin, setWpAdmin] = useState({
    wpadminurl: "",
    wpadminurlerror: false,
    wpadminurlsuffix: "/wp-admin",
    wpadminusername: "",
    wpadminusernameerror: false,
    wpadminpassword: "",
    wpadminpassworderror: false,
  });

  let organizationsInfo = useSelector(
    (state) => state.organizationsInfo.selectedOrg
  );
  const selectedDomain = useSelector((state) => state.sitesInfo.selectedDomain);

  const sites = useSelector((state) => state?.sitesInfo?.selectedSite);
  const isDedicated = sites?.dedicatedInstanceDetails;
  const siteData = siteDetails(sites);
  const isStaging = staging(sites);
  const location = useLocation();
  const lastSegment = lastSegmentPath(location);
  const params = useParams();
  const orgId = params.orgId;
  const siteId = params.siteId;
  const livedom = siteData?.domain.find((item) => item.primary === "Y")?.name;

  useMakeApiCalls(() => {
    getStore().dispatch({
      type: Actions.API_GET_SELECTED_SITE_DETAILS,
      data: { siteId: siteId },
      meta: {
        onSuccess: () => {},
        onError: () => {},
      },
    });
    getStore().dispatch({
      type: Actions.SET_SITE_DETAILS,
      data: {
        orgId: orgId,
        siteId: siteId,
        sitePage: lastSegment,
      },
    });
    getStore().dispatch({
      type: Actions.API_GET_MIGRATION_PROGRESS,
      data: { siteId: siteId },
    });
  });

  const isMigrationProgress = useSelector(
    (state) => state?.sitesInfo?.migrationProgress?.data
  );

  const scrollToSubmit = () => {
    setTimeout(() => {
      targetRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }, 100);
  };

  if (isCurrentHosting.specifydirectory !== "") {
    scrollToSubmit();
  }

  const showSubmit =
    isCurrentHosting.currenthosting === "" ||
    (hasImportantDirs === true && isCurrentHosting.specifydirectory === "") ||
    wpAdmin.wpadminurl === "" ||
    wpAdmin.wpadminusername === "" ||
    wpAdmin.wpadminpassword === "";

  const flushStateVariables = () => {
    setISCurrentHosting({
      currenthosting: "",
      currenthostingerror: false,
      specifydirectory: "",
      specifydirectoryerror: false,
    });
    setIsMultisite(null);
    setHasImportantDirs(null);
    setWpAdmin({
      wpadminurl: "",
      wpadminurlerror: false,
      wpadminurlsuffix: "/wp-admin",
      wpadminusername: "",
      wpadminusernameerror: false,
      wpadminpassword: "",
      wpadminpassworderror: false,
    });
  };

  //popup
  const [popup, setPopup] = useState({
    popupState: false,
    popupType: "",
    popupTitle: "",
    popupSubtitle: "",
    popupSubtitle1: "",
    popupButton: false,
    popupCancel: false,
    popupButtonTitle: "",
    popupButtonFunction: () => {},
  });

  const ActivatePopup = (type, message) => {
    if (type === "error") {
      setPopup({
        popupState: true,
        popupType: "error",
        popupTitle: "Submission Failed",
        popupSubtitle: message || "Something went wrong. Please try again.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
          flushStateVariables();
        },
      });
    }
    if (type === "success") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Details Submitted",
        popupSubtitle: "Your details have been submitted successfully!",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
          flushStateVariables();
          getStore().dispatch({
            type: Actions.API_GET_MIGRATION_PROGRESS,
            data: { siteId: siteId },
          });
        },
      });
    } else if (type === "none") {
      setPopup({ popupState: false });
    }
  };

  const emailId = useEmailId();

  const submitMigrateDetails = () => {
    setLoading(true);
    getStore().dispatch({
      type: Actions.API_SUBMIT_MIGRATE_DETAILS,
      data: {
        siteId: siteId,
        siteName: siteData?.siteName,
        orgId: orgId,
        requestedBy: emailId,
        currentHosting: isCurrentHosting.currenthosting,
        isMultiSite: isMultisite,
        impDirectories: hasImportantDirs,
        impDirectoriesInfo: isCurrentHosting.specifydirectory,
        adminUrl: wpAdmin.wpadminurl,
        adminUsername: wpAdmin.wpadminusername,
        adminPassword: wpAdmin.wpadminpassword,
      },
      meta: {
        onSuccess: () => {
          setLoading(false);
          ActivatePopup("success");
        },
        onError: (data) => {
          setLoading(false);
          ActivatePopup("error", data);
        },
      },
    });
  };

  return (
    <>
      <Grid2 className={styles.Container}>
        <Grid2 className={styles.header}>Site Migration</Grid2>
        <Grid2>
          {siteData?.siteName && (
            <SiteHeaderCard
              name={
                selectedDomain?.environment === "STAGING"
                  ? selectedDomain.domainName
                  : siteData?.siteName
              }
              domain={
                livedom?.length > 0 &&
                (selectedDomain?.environment !== "STAGING" || isDedicated)
                  ? livedom
                  : (selectedDomain?.environment === "STAGING"
                      ? selectedDomain.domainName
                      : siteData?.siteName) +
                    "." +
                    process.env.REACT_APP_TEMP_DOMAIN
              }
              development={isStaging}
              production={getStagingEnv(siteData.staging, STAGING.LIVE)}
              phpClick={() => adminApi("php")}
              wpClick={() =>
                adminApi(
                  "wp",
                  selectedDomain?.environment === "STAGING"
                    ? selectedDomain.domainName
                    : siteData.siteName,
                  selectedDomain?.environment === "STAGING"
                    ? selectedDomain.domainName
                    : livedom?.length > 0
                    ? livedom
                    : null,
                  selectedDomain?.environment === "STAGING" ? true : false
                )
              }
              domainClick={() =>
                adminApi(
                  "domain",
                  selectedDomain?.environment === "STAGING"
                    ? selectedDomain.domainName
                    : siteData.siteName,
                  selectedDomain?.environment === "STAGING"
                    ? selectedDomain.domainName
                    : livedom?.length > 0
                    ? livedom
                    : null,
                  selectedDomain?.environment === "STAGING" ? true : false
                )
              }
              siteId={siteId}
              orgId={orgId}
              image={siteData.imagePath ? siteData.imagePath : null}
              orgInfo={organizationsInfo}
              addOnWaf={siteData.wafStatus}
              addOnPerformanceSite={siteData.performanceSite}
            />
          )}
          <Grid2 className={styles.TabsComponent}>
            <TabsComponent
              selectedTab={cardStatus}
              setSelectedTab={setCardStatus}
              tabs={tabs}
            />
          </Grid2>
        </Grid2>

        {!isMigrationProgress ? (
          <>
            {cardStatus.value === "MigrateViaPlugin" && <SelfMigrate />}
            {cardStatus.value === "MigrateViaBackups" && (
              <ManualMigration siteName={siteData?.siteName} />
            )}

            {cardStatus.value === "RequestExpertMigration" && (
              <>
                <CurrentSiteInfo
                  isCurrentHosting={isCurrentHosting}
                  setISCurrentHosting={setISCurrentHosting}
                  isMultisite={isMultisite}
                  setIsMultisite={setIsMultisite}
                  hasImportantDirs={hasImportantDirs}
                  setHasImportantDirs={setHasImportantDirs}
                />
                <Grid2 className={styles.siteDetails}>
                  <SiteDetails
                    wpAdmin={wpAdmin}
                    setWpAdmin={setWpAdmin}
                    isCurrentHosting={isCurrentHosting}
                    isMultisite={isMultisite}
                    hasImportantDirs={hasImportantDirs}
                  />
                </Grid2>
              </>
            )}
            {cardStatus.value === "RequestExpertMigration" && (
              <Grid2 className={styles.submitBtn} ref={targetRef}>
                <CustomButton
                  disabled={showSubmit}
                  onClick={submitMigrateDetails}
                >
                  {loading ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    "Submit"
                  )}
                </CustomButton>
              </Grid2>
            )}
          </>
        ) : (
          <Grid2 className={styles.imageContainer}>
            <MigrateProcessing className={styles.image} />
            <Grid2 className={styles.label}>
              Migration is under progress for this site!
            </Grid2>
          </Grid2>
        )}
      </Grid2>
      <section>
        <FormPopup
          trigger={popup.popupState}
          setTrigger={setPopup}
          type={popup.popupType}
          title={popup.popupTitle}
          subtitle={popup.popupSubtitle}
          button={popup.popupButton}
          cancel={popup.popupCancel}
          buttonTitle={popup.popupButtonTitle}
          buttonFunction={popup.popupButtonFunction}
          loading={loading}
        />
      </section>
    </>
  );
}
